import { useState } from "react";
import { PageHeader, Section } from "@/components/site/PageChrome";
import { Mail, MessageCircle, Building2, LifeBuoy, Check, Instagram, Facebook, Linkedin, Youtube, Twitter, Send } from "lucide-react";
import { waLink, WHATSAPP_DISPLAY } from "@/components/site/FloatingWhatsApp";
import { HOME } from "@/constants/testIds";

const socials = [
  {
    icon: Instagram,
    l: "Instagram",
    link: "https://instagram.com/time2cash.co",
  },
  {
    icon: Youtube,
    l: "YouTube",
    link: "https://youtube.com/@Time2Cash-Co",
  },
];

export default function ContactPage() {
  const [submitted, setSubmitted] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", subject: "", message: "" });
  const onSubmit = (e) => {
  e.preventDefault();

  const phone = "919988771606"; 
  const message = `*New Website Enquiry*

👤 Name: ${form.name}

📧 Email: ${form.email}

📝 Subject: ${form.subject}

💬 Message:
${form.message}`;

  window.open(
    `https://wa.me/${phone}?text=${encodeURIComponent(message)}`,
    "_blank"
  );
};
  return (
    <>
      <PageHeader
        eyebrow="Support & Contact"
        title="We're here to help."
        subtitle="Reach out for support, business enquiries, or just to say hello. We usually respond within one working day."
      />

      <Section>
        <div className="grid md:grid-cols-3 gap-4">
          <a href="mailto:hello@time2cash.co" data-testid={HOME.contactEmailSupport} className="rounded-3xl bg-white border border-[#EBE8E3] p-6 hover:border-[#FF5A00] transition">
            <LifeBuoy className="w-6 h-6 text-[#FF5A00]" />
            <div className="mt-3 text-xs font-semibold text-[#78716C]">Support</div>
            <div className="font-bold text-[#1A1918] break-all">hello@time2cash.co</div>
          </a>
          <a href="mailto:hello@time2cash.co" data-testid={HOME.contactEmailGeneral} className="rounded-3xl bg-white border border-[#EBE8E3] p-6 hover:border-[#FF5A00] transition">
            <Mail className="w-6 h-6 text-[#FF5A00]" />
            <div className="mt-3 text-xs font-semibold text-[#78716C]">General</div>
            <div className="font-bold text-[#1A1918] break-all">hello@time2cash.co</div>
          </a>
          <a href="mailto:hello@time2cash.co" data-testid={HOME.contactEmailPartners} className="rounded-3xl bg-white border border-[#EBE8E3] p-6 hover:border-[#FF5A00] transition">
            <Building2 className="w-6 h-6 text-[#FF5A00]" />
            <div className="mt-3 text-xs font-semibold text-[#78716C]">Business Partnerships</div>
            <div className="font-bold text-[#1A1918] break-all">hello@time2cash.co</div>
          </a>
        </div>

        <div className="mt-6 grid lg:grid-cols-2 gap-6">
          <div className="rounded-3xl bg-white border border-[#EBE8E3] p-8">
            <h2 className="text-2xl font-bold text-[#1A1918]">Send us an enquiry</h2>
            {!submitted ? (
              <form onSubmit={onSubmit} data-testid="contact-form" className="mt-6 space-y-4">
                <input required data-testid="contact-name" placeholder="Your name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full rounded-xl border border-[#EBE8E3] bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#FF5A00]" />
                <input required type="email" data-testid="contact-email" placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className="w-full rounded-xl border border-[#EBE8E3] bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#FF5A00]" />
                <input required data-testid="contact-subject" placeholder="Subject" value={form.subject} onChange={(e) => setForm({ ...form, subject: e.target.value })} className="w-full rounded-xl border border-[#EBE8E3] bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#FF5A00]" />
                <textarea required data-testid="contact-message" placeholder="Your message" rows={4} value={form.message} onChange={(e) => setForm({ ...form, message: e.target.value })} className="w-full rounded-xl border border-[#EBE8E3] bg-[#FDFBF7] px-4 py-3 text-sm outline-none focus:border-[#FF5A00] resize-none" />
                <button
  type="submit"
  data-testid="contact-submit"
  className="w-full rounded-full bg-[#25D366] hover:bg-[#1EBE5D] text-white py-3.5 font-semibold shadow-lg shadow-green-500/25 transition-colors"
>
  Send via WhatsApp
</button>
              </form>
            ) : (
              <div data-testid="contact-success" className="text-center py-10">
                <div className="w-16 h-16 rounded-full bg-emerald-100 mx-auto flex items-center justify-center">
                  <Check className="w-8 h-8 text-emerald-600" />
                </div>
                <h3 className="mt-4 text-xl font-bold text-[#1A1918]">Message sent!</h3>
                <p className="mt-2 text-[#4A4846]">Thanks for reaching out. Our team will get back to you shortly.</p>
              </div>
            )}
          </div>

          <div className="space-y-4">
            <a href={waLink("Hi Time2Cash! I need some support.")} target="_blank" rel="noopener noreferrer" data-testid="contact-whatsapp" className="block rounded-3xl bg-[#25D366] text-white p-8 hover:opacity-95 transition">
              <MessageCircle className="w-8 h-8" />
              <h3 className="mt-3 text-xl font-bold">WhatsApp Support</h3>
              <p className="mt-1 text-white/90">Chat with our team directly on WhatsApp for quick help.</p>
              <div className="mt-2 font-bold">{WHATSAPP_DISPLAY}</div>
              <span className="mt-4 inline-block font-semibold underline">Start chat →</span>
            </a>
            <div className="rounded-3xl bg-white border border-[#EBE8E3] p-8">
  <div className="text-sm font-semibold text-[#78716C]">
    A Product of
  </div>

  <div className="mt-1 text-2xl font-bold text-[#1A1918]">
    Time2Cash
  </div>

  <div className="mt-1 text-sm font-medium text-[#FF5A00]">
    by DIGISWING Innovation Private Limited
  </div>

  <p className="mt-4 text-sm text-[#4A4846] leading-relaxed">
    Time2Cash is India's hyperlocal community platform that connects people,
    businesses, local tasks, jobs, marketplace, and emergency services—all
    within one trusted app.
  </p>

  <div className="mt-6 text-sm font-semibold text-[#78716C]">
    Follow Time2Cash
  </div>

  <div className="mt-3 flex flex-wrap gap-2">
  {socials.map(({ icon: Icon, l, link }) => (
    <a
      key={l}
      href={link}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 rounded-full bg-[#FFF3ED] px-3 py-2 text-sm font-medium hover:bg-[#FF5A00] hover:text-white transition"
    >
      <Icon className="w-4 h-4" />
      {l}
    </a>
  ))}
</div>
</div>
          </div>
        </div>
      </Section>
    </>
  );
}
